/**
 * SmartDry demo booking — Shopify contact form + Cal.com.
 * 1) Stash lead fields before submit (Shopify still receives the contact form).
 * 2) After successful submit, open Cal.com modal prefilled.
 */
(function () {
  var STORAGE_KEY = 'sd_demo_lead';
  var PENDING_KEY = 'sd_cal_pending';
  var NS = 'sd-demo';
  var root = document.getElementById('sd-cal-root');
  if (!root) return;

  var rawLink = root.getAttribute('data-cal-link') || '';
  var calOrigin = root.getAttribute('data-cal-origin') || 'https://cal.com';
  var calLink = rawLink
    .replace(/^https?:\/\/(www\.)?cal\.(com|eu)\//, '')
    .replace(/^cal\.(com|eu)\//, '')
    .replace(/^\//, '');
  var embedScript =
    calOrigin.indexOf('cal.eu') !== -1
      ? 'https://app.cal.eu/embed/embed.js'
      : 'https://app.cal.com/embed/embed.js';
  var enabled = root.getAttribute('data-enabled') === 'true' && !!calLink;
  var dialog = document.getElementById('sd-cal-dialog');
  var embed = document.getElementById('sd-cal-embed');
  var closeBtn = dialog && dialog.querySelector('[data-sd-cal-close]');
  var calReady = false;
  var calLoading = null;

  function readLead() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function writeLead(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      sessionStorage.setItem(PENDING_KEY, '1');
    } catch (e) {}
  }

  function clearPending() {
    try {
      sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {}
  }

  function fieldValue(form, names) {
    for (var i = 0; i < names.length; i++) {
      var el = form.querySelector('[name="' + names[i] + '"]');
      if (el && el.value) return el.value.trim();
    }
    return '';
  }

  function stashFromForm(form) {
    var name = fieldValue(form, ['contact[name]', 'name']);
    var email = fieldValue(form, ['contact[email]', 'email']);
    var business = fieldValue(form, ['contact[business_name]']);
    var phone = fieldValue(form, ['contact[phone]']);
    var stores = fieldValue(form, ['contact[stores]']);
    var context = fieldValue(form, ['contact[context]']) || 'Demo request';

    var types = [];
    form.querySelectorAll('input[type="checkbox"][name^="contact[type_"]:checked').forEach(function (box) {
      if (box.value) types.push(box.value);
    });

    var notes = [];
    if (business) notes.push('Business: ' + business);
    if (stores) notes.push('Stores: ' + stores);
    if (types.length) notes.push('Type: ' + types.join(', '));
    if (phone) notes.push('Phone: ' + phone);
    notes.push('Source: ' + context);

    writeLead({
      name: name,
      email: email,
      notes: notes.join(' · ')
    });
  }

  function ensureCal() {
    if (calReady && window.Cal && window.Cal.ns && window.Cal.ns[NS]) {
      return Promise.resolve();
    }
    if (calLoading) return calLoading;

    calLoading = new Promise(function (resolve, reject) {
      (function (C, A, L) {
        var p = function (a, ar) {
          a.q.push(ar);
        };
        var d = C.document;
        C.Cal =
          C.Cal ||
          function () {
            var cal = C.Cal;
            var ar = arguments;
            if (!cal.loaded) {
              cal.ns = {};
              cal.q = cal.q || [];
              var script = d.createElement('script');
              script.src = A;
              script.async = true;
              script.onload = function () {
                calReady = true;
                resolve();
              };
              script.onerror = function () {
                reject(new Error('Cal.com failed to load'));
              };
              d.head.appendChild(script);
              cal.loaded = true;
            }
            if (ar[0] === L) {
              var api = function () {
                p(api, arguments);
              };
              var namespace = ar[1];
              api.q = api.q || [];
              if (typeof namespace === 'string') {
                cal.ns[namespace] = cal.ns[namespace] || api;
                p(cal.ns[namespace], ar);
                p(cal, ['initNamespace', namespace]);
              } else {
                p(cal, ar);
              }
              return;
            }
            p(cal, ar);
          };
      })(window, embedScript, 'init');

      window.Cal('init', NS, { origin: calOrigin });
      window.Cal.ns[NS]('ui', {
        hideEventTypeDetails: false,
        layout: 'month_view',
        theme: 'light',
        styles: {
          branding: {
            brandColor: '#202020'
          }
        }
      });
      try {
        window.Cal.ns[NS]('on', {
          action: '*',
          callback: function (event) {
            var action = '';
            if (event) {
              action = String(event.action || event.type || (event.detail && event.detail.type) || '');
            }
            action = action.toLowerCase();
            if (
              action.indexOf('close') !== -1 ||
              action.indexOf('__close') !== -1 ||
              action.indexOf('overlay') !== -1
            ) {
              unlockPageScroll();
            }
          }
        });
      } catch (err) {}

      if (calReady) resolve();
      setTimeout(function () {
        if (!calReady) resolve();
      }, 2500);
    });

    return calLoading;
  }

  var scrollY = 0;
  var scrollLocked = false;

  function lockPageScroll() {
    if (scrollLocked) return;
    scrollY = window.scrollY || window.pageYOffset || 0;
    scrollLocked = true;
    document.documentElement.classList.add('sd-cal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockPageScroll() {
    if (!scrollLocked) return;
    scrollLocked = false;
    document.documentElement.classList.remove('sd-cal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function openBooking(lead) {
    if (!enabled) return;

    lead = lead || readLead() || {};
    lockPageScroll();

    ensureCal()
      .then(function () {
        /* Cal’s native modal — correct calendar layout (no crushed iframe shell) */
        window.Cal.ns[NS]('modal', {
          calLink: calLink,
          config: {
            layout: 'month_view',
            theme: 'light',
            name: lead.name || '',
            email: lead.email || '',
            notes: lead.notes || ''
          }
        });
        clearPending();

        /* Unlock when Cal overlay is dismissed */
        window.setTimeout(function () {
          var calLayer = document.querySelector('cal-modal-box, .cal-modal-box, [data-cal-namespace="' + NS + '"]');
          if (!calLayer) return;
          var mo = new MutationObserver(function () {
            if (!document.body.contains(calLayer) || calLayer.getAttribute('open') === 'false') {
              unlockPageScroll();
              mo.disconnect();
            }
          });
          mo.observe(document.body, { childList: true, subtree: true, attributes: true });
        }, 300);
      })
      .catch(function () {
        if (dialog && embed) {
          if (typeof dialog.showModal === 'function') {
            if (!dialog.open) dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          embed.innerHTML =
            '<p class="sd-cal__empty">We couldn’t load the calendar. Please email us and we’ll book your demo manually.</p>';
        } else {
          unlockPageScroll();
        }
      });
  }

  function closeBooking() {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    unlockPageScroll();
  }

  function bindForms() {
    document.querySelectorAll('form.sd-lead-form').forEach(function (form) {
      form.addEventListener('submit', function () {
        if (!enabled) return;
        stashFromForm(form);
      });
    });

    document.querySelectorAll('[data-sd-cal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openBooking();
      });
    });
  }

  function textLooksLikeEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value || '');
  }

  function stashFromShopifyFormsShadow(shadow) {
    if (!shadow) return;
    var inputs = shadow.querySelectorAll('input, textarea, select');
    var name = '';
    var email = '';
    var notes = [];

    inputs.forEach(function (input) {
      var value = (input.value || '').trim();
      if (!value) return;
      var key = ((input.name || '') + ' ' + (input.id || '') + ' ' + (input.getAttribute('aria-label') || '') + ' ' + (input.placeholder || '')).toLowerCase();
      var type = (input.type || '').toLowerCase();

      if (!email && (type === 'email' || key.indexOf('email') !== -1 || textLooksLikeEmail(value))) {
        email = value;
        return;
      }
      if (!name && (key.indexOf('name') !== -1 || key.indexOf('full') !== -1) && type !== 'email') {
        name = value;
        return;
      }
      if (type === 'hidden' || type === 'checkbox' || type === 'radio' || type === 'submit') return;
      notes.push(value);
    });

    writeLead({
      name: name,
      email: email,
      notes: notes.length ? 'Shopify Forms · ' + notes.join(' · ') : 'Shopify Forms demo request'
    });
  }

  function isFormsSuccessStep(step) {
    if (!step) return false;
    step = String(step).toLowerCase();
    return (
      step.indexOf('success') !== -1 ||
      step.indexOf('thank') !== -1 ||
      step.indexOf('complete') !== -1 ||
      step.indexOf('end') !== -1 ||
      step === 'submitted'
    );
  }

  function bindShopifyFormEmbed(formEmbed) {
    if (!formEmbed || formEmbed.dataset.sdCalBound === '1') return;
    formEmbed.dataset.sdCalBound = '1';

    var opened = false;

    function openOnce() {
      if (opened || !enabled) return;
      opened = true;
      openBooking();
    }

    function attach() {
      var shadow = formEmbed.shadowRoot;
      if (!shadow) return false;

      var form = shadow.querySelector('form');
      if (form && form.dataset.sdSubmitBound !== '1') {
        form.dataset.sdSubmitBound = '1';
        form.addEventListener(
          'submit',
          function () {
            stashFromShopifyFormsShadow(shadow);
          },
          true
        );
      }

      var appEmbed =
        shadow.querySelector('#app-embed') ||
        shadow.querySelector('[data-current-step]') ||
        shadow.querySelector('[class*="form"]');

      if (appEmbed && appEmbed.dataset.sdStepBound !== '1') {
        appEmbed.dataset.sdStepBound = '1';
        var mo = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type !== 'attributes') return;
            var step = appEmbed.getAttribute('data-current-step') || '';
            if (isFormsSuccessStep(step)) openOnce();
          });
          if (
            shadow.querySelector('[data-testid*="success"], .form-success, [class*="success"], [class*="thank"]')
          ) {
            openOnce();
          }
        });
        mo.observe(appEmbed, {
          attributes: true,
          attributeFilter: ['data-current-step', 'class', 'data-state'],
          subtree: true,
          childList: true
        });
      }

      /* Shopify Forms embed — brand colors */
      try {
        if (shadow && !shadow.sdBrandStyled) {
          shadow.sdBrandStyled = true;
          var sheet = new CSSStyleSheet();
          [
            ':host, #app-embed, body, p, label, span, input, select, textarea { color: #202020 !important; font-family: Onest, system-ui, sans-serif !important; }',
            'a { color: #1878B9 !important; }',
            'input:focus, select:focus, textarea:focus { border-color: #1878B9 !important; outline-color: #1878B9 !important; box-shadow: 0 0 0 3px rgba(24,120,185,0.18) !important; }',
            'button[type="submit"], button[data-submit], [type="submit"] { background: #202020 !important; color: #FFFFFF !important; border-radius: 10px !important; }',
            '[class*="error"], [aria-invalid="true"], .error, [data-error] { color: #E02229 !important; border-color: #E02229 !important; }'
          ].forEach(function (rule) {
            try {
              sheet.insertRule(rule, sheet.cssRules.length);
            } catch (err) {}
          });
          shadow.adoptedStyleSheets = (shadow.adoptedStyleSheets || []).concat(sheet);
        }
      } catch (err) {}

      return !!(form || appEmbed);
    }

    if (attach()) return;

    var boot = new MutationObserver(function () {
      if (attach()) boot.disconnect();
    });
    boot.observe(formEmbed, { childList: true, subtree: true, attributes: true });

    var tries = 0;
    var poll = window.setInterval(function () {
      tries += 1;
      if (attach() || tries > 40) window.clearInterval(poll);
    }, 250);
  }

  function bindShopifyForms() {
    if (!enabled) return;

    document.querySelectorAll('[data-sd-forms-slot] form-embed, [data-sd-forms-app] form-embed, form-embed').forEach(bindShopifyFormEmbed);

    var pageObserver = new MutationObserver(function () {
      document.querySelectorAll('form-embed').forEach(bindShopifyFormEmbed);
    });
    pageObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeBooking);
  }

  if (dialog) {
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeBooking();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeBooking();
    });
  }

  bindForms();
  bindShopifyForms();

  try {
    if (enabled && sessionStorage.getItem(PENDING_KEY) === '1' && document.querySelector('[data-sd-cal-success]')) {
      /* Keep the success state in view, then open — avoids mid-page jump when Cal mounts */
      var success = document.querySelector('[data-sd-cal-success]');
      if (success && typeof success.scrollIntoView === 'function') {
        success.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      window.requestAnimationFrame(function () {
        openBooking();
      });
    }
  } catch (e) {}

  window.SmartDryCal = {
    open: openBooking,
    close: closeBooking
  };
})();
